import * as yup from 'yup'

const userValidationSchema = yup.object().shape({
  type: yup.string().required('Required *'),
  firstName: yup.string().required('Required *'),
  lastName: yup.string().required('Required *'),
  email: yup.string().email().required('Required *'),
  phone: yup.string().required('Required *'),
  name: yup.string().when('type', {
    is: 'speaker',
    then: (schema) => schema.notRequired(),
    otherwise: (schema) => schema.required('Required *'),
  }),
  organizationIds: yup
    .array()
    .of(yup.string())
    .min(1, 'Required *')
    .required('Required *'),
  image: yup.string().when('type', {
    is: 'speaker',
    then: (schema) => schema.required('Required *'),
    otherwise: (schema) => schema.notRequired(),
  }),
  description: yup.string().when('type', {
    is: 'speaker',
    then: (schema) => schema.required('Required *'),
    otherwise: (schema) => schema.notRequired(),
  }),
  designation: yup.string().when('type', {
    is: 'speaker',
    then: (schema) => schema.required('Required *'),
    otherwise: (schema) => schema.notRequired(),
  }),
  password: yup.string().test({
    name: 'conditionalPassword',
    test(value) {
      const obj = this.parent

      // eslint-disable-next-line no-underscore-dangle
      if (!obj._id && !value) {
        return this.createError({
          path: 'password',
          message: 'Password is required when _id is not present',
        })
      }

      return true
    },
  }),
})

const userInitialValues = {
  firstName: '',
  lastName: '',
  name: '',
  company: '',
  jobTitle: '',
  organizationIds: [],
  teamId: '',
  phone: '',
  email: '',
  workLocation: '',
  emergencyContactName: '',
  emergencyContactRelationship: '',
  emergencyContactPhoneNumber: '',
  managerName: '',
  managerPhoneNumber: '',
  status: '',
  password: '',
  type: '',
  image: '',
  description: '',
  designation: '',
}

const GENDERS = [
  {
    value: 'Male',
    label: 'Male',
  },
  {
    value: 'Female',
    label: 'Female',
  },
]
const FIELDS = [
  {
    value: 'FIELD-1',
    label: 'Field 1',
  },
  {
    value: 'FIELD-2',
    label: 'Field 2',
  },
]
const USER_STATUS = [
  {
    value: 'pending',
    label: 'Pending',
  },
  {
    value: 'approved',
    label: 'Approve',
  },
  {
    value: 'rejected',
    label: 'Reject',
  },
]
const USER_TYPE = [
  {
    value: 'admin',
    label: 'Admin',
  },
  {
    value: 'user',
    label: 'User',
  },
  {
    value: 'speaker',
    label: 'Speaker',
  },
]
export {
  userValidationSchema,
  userInitialValues,
  GENDERS,
  FIELDS,
  USER_STATUS,
  USER_TYPE,
}
